module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C229"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id0"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C230"
  }, [_vm._v("Great thanks to my traveling companions, who also read the draft chapters, David and Helen Stone and Daniel Eilon. ")]), _vm._v(" "), _c('p', {
    staticClass: "P37"
  }, [_vm._v("Deep thanks also to my colleagues in the Cambridge Victorian Studies Group, Clare Pettitt and Peter Mandler, who read and made helpful comments on the manuscript, as did Miriam Leonard, as ever. I discussed it all with Helen Morales, who is on a pilgrimage of her own. The readers for the University of Chicago Press were exceptional for the understanding they evinced in their reports and the trouble they took in reading with such care. ")]), _vm._v(" "), _c('p', {
    staticClass: "P37"
  }, [_vm._v("Most profound thanks to my wife, for traveling, reading, and putting up with the whole project. She found several new ways to articulate “Reader, I married him” during the composition of this book. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35fe3b1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Acknowle.vue
// module id = 69
// module chunks = 0